import gatewayService from '@/modules/common/services/gatewayService';

const BASE_ROUTE = 'business/notificationscenter/v1';
const SETTINGS_ROUTE = 'staff/settings';
const V3_BASE_ROUTE = 'v3/communication/notification_templates';

const getAllNotificationTemplates = async () => gatewayService.get(`${V3_BASE_ROUTE}`)
  .then((res) => {
    const data = res.data?.data || res.data;
    return data;
  });

const getStaffSettings = async (staffUid) => gatewayService.get(`${BASE_ROUTE}/${SETTINGS_ROUTE}?filter[staff_uid][eq]=${staffUid}&per_page=100`)
  .then((res) => res.data?.data?.staff_settings || res.data?.staff_settings || []);

const updateSingleSetting = async (setting) => {
  try {
    return await gatewayService.put(`${BASE_ROUTE}/${SETTINGS_ROUTE}/${setting.uid}`, {
      ...setting,
    })
      .then((res) => res.data?.data || res.data);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
    return undefined;
  }
};

const createSingleSetting = async (setting) => {
  try {
    return await gatewayService.post(`${BASE_ROUTE}/${SETTINGS_ROUTE}`, {
      ...setting,
    }).then((res) => res.data?.data || res.data);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
    return undefined;
  }
};

export default {
  getAllNotificationTemplates,
  getStaffSettings,
  updateSingleSetting,
  createSingleSetting,
};
